import { Component, Input } from '@angular/core';

@Component({
  selector: 'dots',
  styleUrls: ['../designing.component.scss', './dots.component.scss'],
  templateUrl: './dots.component.html',
})
export class DesigningDotsComponent {
  @Input() stepsCount;
  @Input() activeStep;
  @Input() type: 'tips' | 'tutorial';

  constructor() {}

  getClasses(index) {
    return index === this.activeStep - 1 ? this.type : '';
  }
}
